export const CountryEnum = {
    Brasil: 'BR',
    Argentina: 'AR',
    Equador: 'EC',
    Peru: 'PE',
    Colombia: 'CO',
    Uruguai: 'UY',
    Chile: 'CL',
    RepublicaDominicana: 'DO',
    Guatemala: 'GT',
    ElSalvador: 'SV',
    Panama: 'PA',
};

export const CountryAcronym = {
    br: 1,
    ar: 2,
    ec: 3,
    pe: 4,
    co: 5,
    uy: 6,
    cl: 7,
    do: 8,
    gt: 9,
    sv: 11,
    pa: 12,
};

const acronymId = Object
    .keys(CountryAcronym)
    .reduce((acc, curr) => {
        acc[CountryAcronym[curr]] = curr.toUpperCase();
        return acc;
    }, {});

export const getCountryAcronym = (id) => acronymId[id];



// WEBPACK FOOTER //
// ./src/enuns/country.enum.js